"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalendarWithoutAnalytics = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _calendarBase = require("calendar-base");

var _lodash = _interopRequireDefault(require("lodash.pick"));

var _react = _interopRequireWildcard(require("react"));

var _v = _interopRequireDefault(require("uuid/v1"));

var _analyticsNext = require("@atlaskit/analytics-next");

var _package = require("../../package.json");

var _util = require("../util");

var _Date = _interopRequireDefault(require("./Date"));

var _Heading = _interopRequireDefault(require("./Heading"));

var _Calendar = require("../styled/Calendar");

var arrowKeys = {
  ArrowDown: 'down',
  ArrowLeft: 'left',
  ArrowRight: 'right',
  ArrowUp: 'up'
};
var daysPerWeek = 7;
var monthsPerYear = 12;

function getUniqueId(prefix) {
  return "".concat(prefix, "-").concat((0, _v.default)());
}

function padToTwo(number) {
  return number <= 99 ? "0".concat(number).slice(-2) : "".concat(number);
}

var Calendar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Calendar, _Component);

  function Calendar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Calendar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Calendar).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "calendar", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "container", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getState", function () {
      return (0, _objectSpread2.default)({}, _this.state, (0, _lodash.default)(_this.props, ['day', 'disabled', 'selected', 'month', 'previouslySelected', 'year', 'today']));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleContainerKeyDown", function (e) {
      var key = e.key;
      var arrowKey = arrowKeys[key];

      if (key === 'Enter' || key === ' ') {
        var _this$getState = _this.getState(),
            selectDay = _this$getState.day,
            selectMonth = _this$getState.month,
            selectYear = _this$getState.year;

        e.preventDefault();

        _this.triggerOnSelect({
          day: selectDay,
          year: selectYear,
          month: selectMonth
        });
      } else if (arrowKey) {
        e.preventDefault();

        _this.navigate(arrowKey);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleClickDay", function (_ref) {
      var year = _ref.year,
          month = _ref.month,
          day = _ref.day;

      _this.triggerOnSelect({
        year: year,
        month: month,
        day: day
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleClickNext", function () {
      var _this$getState$_this$ = (0, _objectSpread2.default)({}, _this.getState(), _this.getNextMonth()),
          day = _this$getState$_this$.day,
          month = _this$getState$_this$.month,
          year = _this$getState$_this$.year;

      _this.triggerOnChange({
        day: day,
        month: month,
        year: year,
        type: 'next'
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleClickPrev", function () {
      var _this$getState$_this$2 = (0, _objectSpread2.default)({}, _this.getState(), _this.getPrevMonth()),
          day = _this$getState$_this$2.day,
          month = _this$getState$_this$2.month,
          year = _this$getState$_this$2.year;

      _this.triggerOnChange({
        day: day,
        month: month,
        year: year,
        type: 'prev'
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleContainerBlur", function () {
      _this.setState({
        day: 0
      });

      _this.props.onBlur();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleContainerFocus", function () {
      _this.setState({
        day: _this.getState().day || 1
      });

      _this.props.onFocus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "refContainer", function (e) {
      _this.container = e;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "triggerOnChange", function (_ref2) {
      var year = _ref2.year,
          month = _ref2.month,
          day = _ref2.day,
          type = _ref2.type;
      var iso = (0, _util.dateToString)({
        year: year,
        month: month,
        day: day
      });

      _this.props.onChange({
        day: day,
        month: month,
        year: year,
        iso: iso,
        type: type
      });

      _this.setState({
        day: day,
        month: month,
        year: year
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "triggerOnSelect", function (_ref3) {
      var year = _ref3.year,
          month = _ref3.month,
          day = _ref3.day;
      var iso = (0, _util.dateToString)({
        year: year,
        month: month,
        day: day
      });

      _this.props.onSelect({
        day: day,
        month: month,
        year: year,
        iso: iso
      });

      _this.setState({
        previouslySelected: _this.getState().selected,
        selected: [iso]
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getCalendarWeeks", function (mappedState) {
      var day = mappedState.day,
          year = mappedState.year,
          month = mappedState.month,
          disabled = mappedState.disabled,
          previouslySelected = mappedState.previouslySelected,
          selected = mappedState.selected,
          today = mappedState.today;

      var calendar = _this.calendar.getCalendar(year, month - 1);

      var weeks = [];
      var shouldDisplaySixthWeek = calendar.length % 6; // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
      // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
      // catering to always showing 6 weeks.

      if (shouldDisplaySixthWeek) {
        var lastDayIsSibling = calendar[calendar.length - 1].siblingMonth;
        var sliceStart = lastDayIsSibling ? daysPerWeek : 0;
        calendar.push.apply(calendar, (0, _toConsumableArray2.default)(_this.calendar.getCalendar(year, month).slice(sliceStart, sliceStart + daysPerWeek).map(function (e) {
          return (0, _objectSpread2.default)({}, e, {
            siblingMonth: true
          });
        })));
      }

      calendar.forEach(function (date) {
        var dateAsString = (0, _util.dateToString)(date, {
          fixMonth: true
        });
        var week;

        if (date.weekDay === 0) {
          week = {
            key: dateAsString,
            components: []
          };
          weeks.push(week);
        } else {
          week = weeks[weeks.length - 1];
        }

        var isDisabled = disabled.indexOf(dateAsString) > -1;
        var isFocused = day === date.day && !date.siblingMonth;
        var isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
        var isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
        var isSiblingMonth = date.siblingMonth;
        var isToday = today === dateAsString;
        week.components.push(_react.default.createElement(_Date.default, {
          disabled: isDisabled,
          focused: isFocused,
          isToday: isToday,
          key: dateAsString,
          month: date.month + 1,
          onClick: _this.handleClickDay,
          previouslySelected: isPreviouslySelected,
          selected: isSelected,
          sibling: isSiblingMonth,
          year: date.year
        }, date.day));
      });
      return weeks;
    });
    var now = new Date();
    var thisDay = now.getDate();
    var thisMonth = now.getMonth() + 1;
    var thisYear = now.getFullYear();
    _this.state = {
      day: _this.props.defaultDay || thisDay,
      disabled: _this.props.defaultDisabled,
      selected: _this.props.defaultSelected,
      month: _this.props.defaultMonth || thisMonth,
      previouslySelected: _this.props.defaultPreviouslySelected,
      year: _this.props.defaultYear || thisYear,
      today: _this.props.today || "".concat(thisYear, "-").concat(padToTwo(thisMonth), "-").concat(padToTwo(thisDay))
    };
    _this.calendar = new _calendarBase.Calendar({
      siblingMonths: true,
      weekNumbers: true
    });
    return _this;
  } // All state needs to be accessed via this function so that the state is mapped from props
  // correctly to allow controlled/uncontrolled usage.


  (0, _createClass2.default)(Calendar, [{
    key: "getNextMonth",
    value: function getNextMonth() {
      var _this$getState2 = this.getState(),
          month = _this$getState2.month,
          year = _this$getState2.year;

      if (month === monthsPerYear) {
        month = 1;
        year += 1;
      } else {
        month += 1;
      }

      return {
        month: month,
        year: year
      };
    }
  }, {
    key: "getPrevMonth",
    value: function getPrevMonth() {
      var _this$getState3 = this.getState(),
          month = _this$getState3.month,
          year = _this$getState3.year;

      if (month === 1) {
        month = monthsPerYear;
        year -= 1;
      } else {
        month -= 1;
      }

      return {
        month: month,
        year: year
      };
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.container) {
        this.container.focus();
      }
    }
  }, {
    key: "navigate",
    value: function navigate(type) {
      var _this$getState4 = this.getState(),
          day = _this$getState4.day,
          month = _this$getState4.month,
          year = _this$getState4.year;

      if (type === 'down') {
        var next = day + daysPerWeek;

        var daysInMonth = _calendarBase.Calendar.daysInMonth(year, month - 1);

        if (next > daysInMonth) {
          var _this$getNextMonth = this.getNextMonth(),
              nextMonth = _this$getNextMonth.month,
              nextYear = _this$getNextMonth.year;

          this.triggerOnChange({
            year: nextYear,
            month: nextMonth,
            day: next - daysInMonth,
            type: type
          });
        } else {
          this.triggerOnChange({
            year: year,
            month: month,
            day: next,
            type: type
          });
        }
      } else if (type === 'left') {
        var prev = day - 1;

        if (prev < 1) {
          var _this$getPrevMonth = this.getPrevMonth(),
              prevMonth = _this$getPrevMonth.month,
              prevYear = _this$getPrevMonth.year;

          var prevDay = _calendarBase.Calendar.daysInMonth(prevYear, prevMonth - 1);

          this.triggerOnChange({
            year: prevYear,
            month: prevMonth,
            day: prevDay,
            type: type
          });
        } else {
          this.triggerOnChange({
            year: year,
            month: month,
            day: prev,
            type: type
          });
        }
      } else if (type === 'right') {
        var _next = day + 1;

        var _daysInMonth = _calendarBase.Calendar.daysInMonth(year, month - 1);

        if (_next > _daysInMonth) {
          var _this$getNextMonth2 = this.getNextMonth(),
              _nextMonth = _this$getNextMonth2.month,
              _nextYear = _this$getNextMonth2.year;

          this.triggerOnChange({
            year: _nextYear,
            month: _nextMonth,
            day: 1,
            type: type
          });
        } else {
          this.triggerOnChange({
            year: year,
            month: month,
            day: _next,
            type: type
          });
        }
      } else if (type === 'up') {
        var _prev = day - daysPerWeek;

        if (_prev < 1) {
          var _this$getPrevMonth2 = this.getPrevMonth(),
              _prevMonth = _this$getPrevMonth2.month,
              _prevYear = _this$getPrevMonth2.year;

          var _prevDay = _calendarBase.Calendar.daysInMonth(_prevYear, _prevMonth - 1) + _prev;

          this.triggerOnChange({
            year: _prevYear,
            month: _prevMonth,
            day: _prevDay,
            type: type
          });
        } else {
          this.triggerOnChange({
            year: year,
            month: month,
            day: _prev,
            type: type
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var mappedState = this.getState();
      var innerProps = this.props.innerProps;
      var announceId = getUniqueId('announce');
      return _react.default.createElement("div", (0, _extends2.default)({}, innerProps, {
        onBlur: this.handleContainerBlur,
        onFocus: this.handleContainerFocus,
        onKeyDown: this.handleContainerKeyDown,
        role: "presentation"
      }), _react.default.createElement(_Calendar.Announcer, {
        id: announceId,
        "aria-live": "assertive",
        "aria-relevant": "text"
      }, new Date(mappedState.year, mappedState.month, mappedState.day).toString()), _react.default.createElement(_Calendar.Wrapper, {
        "aria-describedby": announceId,
        "aria-label": "calendar",
        innerRef: this.refContainer,
        role: "grid",
        tabIndex: 0
      }, _react.default.createElement(_Heading.default, {
        month: mappedState.month,
        year: mappedState.year,
        handleClickNext: this.handleClickNext,
        handleClickPrev: this.handleClickPrev
      }), _react.default.createElement(_Calendar.CalendarTable, {
        role: "presentation"
      }, _react.default.createElement(_Calendar.CalendarThead, null, _react.default.createElement("tr", null, (0, _util.makeArrayFromNumber)(daysPerWeek).map(function (i) {
        return _react.default.createElement(_Calendar.CalendarTh, {
          key: i
        }, (0, _util.getShortDayName)(i));
      }))), _react.default.createElement(_Calendar.CalendarTbody, null, this.getCalendarWeeks(mappedState).map(function (week) {
        return _react.default.createElement("tr", {
          key: week.key
        }, week.components);
      })))));
    }
  }]);
  return Calendar;
}(_react.Component);

exports.CalendarWithoutAnalytics = Calendar;
(0, _defineProperty2.default)(Calendar, "defaultProps", {
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onSelect: function onSelect() {},
  innerProps: {},
  defaultDay: 0,
  defaultDisabled: [],
  defaultSelected: [],
  defaultPreviouslySelected: []
});
var createAndFireEventOnAtlaskit = (0, _analyticsNext.createAndFireEvent)('atlaskit');

var _default = (0, _analyticsNext.withAnalyticsContext)({
  componentName: 'calendar',
  packageName: _package.name,
  packageVersion: _package.version
})((0, _analyticsNext.withAnalyticsEvents)({
  onChange: createAndFireEventOnAtlaskit({
    action: 'changed',
    actionSubject: 'calendarDate',
    attributes: {
      componentName: 'calendar',
      packageName: _package.name,
      packageVersion: _package.version
    }
  }),
  onSelect: createAndFireEventOnAtlaskit({
    action: 'selected',
    actionSubject: 'calendarDate',
    attributes: {
      componentName: 'calendar',
      packageName: _package.name,
      packageVersion: _package.version
    }
  })
})(Calendar));

exports.default = _default;